import React, { useRef } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import { Button, Card, Row, Col, Form, Offcanvas, Image } from 'react-bootstrap';
import transaction from "../../actions/transaction";
import moment from 'moment';
import { currencyConverter } from "../../utils";
import {ReactComponent as FilterSvg} from './../../assets/icons/svg/filter.svg';
import {ReactComponent as CheckSvg} from './../../assets/icons/svg/check.svg';
import ListTransaction from "../../components/ListTransaction";
import { toPng } from 'html-to-image';

export default function MutationProof() {
   const navigate = useNavigate();
   const [trnc, setTrnc] = useState([]);
   const { id, slug } = useParams();
   const [loading, setLoading] = useState(true);
   const [load, setLoad] = useState(false);
   const elementRef = useRef(null);

  useEffect(() => {
   transaction.actions.get_transaction_history_detail(id, slug).then((res)=>{
      setTrnc(res?.activity)
      setLoading(false)
    });
  },[])
  
  const onDownload = () => {
   setLoad(true)
   toPng(elementRef.current, { cacheBust: false }).then((dataUrl) => {
      const link = document.createElement("a");
      link.download = "my-image-name.png";
      link.href = dataUrl;
      link.click();
   })
   .catch((err) => {
      console.log(err);
   });
  }
   return (
   <div className="bg-gray vh-100">
      <div className="fixed-top header bg-gray">
         <div className="text-center fw-semibold">
            Bukti Transaksi
         </div>
         <Button className="btn btn-icon btn-success btn-sm btn-radius btn-nav-back" onClick={() => navigate(-1)}>
               <i className="ph-arrow-left text-light"></i>
         </Button>
      </div>
      
      <div className="mx-4 mt-5 mb-2 pt-5 pb-3 border-bottom">
         <div className="mt-4">
            <div className={"d-flex align-items-center " + (loading ? "skeleton skeleton-list":'')}>
               <div style={{
                     height:'60px', 
                     width:'60px', 
                     borderRadius:'18px', 
                     backgroundImage: 'url('+trnc?.partner?.avatar+')',
                     backgroundSize: 'cover'
                  }}
               />
               <div className="ms-3">
                  <div className="fw-bold">{trnc?.partner?.name}</div>
                  <div className="text-secondary ts-sm">{trnc?.name}</div>
                  <div className="text-secondary ts-sm">{moment(new Date(trnc?.created_at)).format('DD MMM YYYY HH:mm') + ' WIB'}</div>
               </div>
            </div>
         </div>
      </div>
      <div ref={elementRef} style={{background:'#f6f6f6', padding:'10px 0'}}>
         <div className="mx-4 border-bottom">
            <div className="mb-3">
               <div className="text-secondary ts-sm">Penerima</div>
               <div className={"fw-semibold text-dark " + (loading ? 'skeleton':'')}>{trnc?.partner?.name}</div>
            </div>
            <div className="mb-3">
               <div className="text-secondary ts-sm">Total Sampah</div>
               {trnc.meta ? 
                  <ul>
                     {trnc?.meta.map((data,key) => {
                        return (
                           <li key={key} className="fw-semibold text-dark">{data?.attributes?.trash_type} - {data?.attributes?.category_name} - {data?.name} ({data?.quantity} Kg)</li>
                        )
                     })}
                  </ul> :
                  "Tidak ada data sampah"
               }
            </div>
            <div className="mb-3">
               <div className="text-secondary ts-sm">Biaya Penjemputan</div>
               <div className="fw-semibold text-dark">{currencyConverter(trnc?.pickup_fee)}</div>
            </div>
            <div className="mb-3">
               <div className="text-secondary ts-sm">Total Transaksi</div>
               <div className="fw-semibold text-dark">{currencyConverter(trnc?.total_amount)}</div>
            </div>
            <div className="mb-3">
               <div className="text-secondary ts-sm">Metode</div>
               <div className="fw-semibold text-dark">{trnc?.pickup_fee == 0 ? 'Setor Langsung' : 'Permintaan Jemput'}</div>
            </div>
         </div>

         <div className="px-4 mt-3">
            <div className="text-secondary ts-sm">Pengirim</div>
            <div className="fw-semibold text-dark">
               {trnc.meta ? trnc?.meta[0]?.attributes?.client_name : ''}
            </div>
         </div>
      </div>

      <div className="d-grid gap-2 fixed-bottom p-4">
         <Button className="btn-auth rounded-pill p-3" variant="success" onClick={onDownload}>
            UNDUH BUKTI TRANSAKSI
         </Button>
         <Button className="btn-auth rounded-pill p-3" variant="outline-success" onClick={onDownload}>
            BAGIKAN BUKTI TRANSAKSI
         </Button>
      </div>
   </div>
  );
}